import React from "react";

const DefaultLayout = (props) => {
  return (
    <>
      <div>{props.children}</div>
    </>
  );

}

export default DefaultLayout;
